const {
	getRequest,
	postRequest,
	putRequest,
	deleteRequest,
} = require("./http-helper");
const api = "institutions";

const createInstitution = ({
	alias,
	allowInstitutionalLogin,
	additionalInformationMessage,
	allowedDeliveryMethods,
	allowedInstitutionalDeliveryMethods,
	allowedInstitutionalPaymentMethods,
	allowedPaymentMethods,
	alternateCode,
	deliveryMethodMessage,
	depots,
	headquarters,
	hidden,
	institutionType,
	name,
	nit,
	nitInstitutional,
	onlyInstitutional,
	publishers,
	requestAdditionalDetails,
	requestAdditionalDetailsLevel,
	requestFavoriteHeadquarter,
	requestInstitutionalEmail,
	requestOrderDocument,
	requestUserTypeSelection,
	saleType,
	state,
	tags,
	useTags,
	userTypes,
	watcher,
	watchers,
	zone,
	email,
	phoneNumber,
}) => {
	return new Promise((resolve, reject) => {
		postRequest(
			api,
			{
				alias,
				allowInstitutionalLogin,
				additionalInformationMessage,
				allowedDeliveryMethods,
				allowedInstitutionalDeliveryMethods,
				allowedInstitutionalPaymentMethods,
				allowedPaymentMethods,
				alternateCode,
				deliveryMethodMessage,
				depots,
				headquarters,
				hidden,
				institutionType,
				name,
				nit,
				nitInstitutional,
				onlyInstitutional,
				publishers,
				requestAdditionalDetails,
				requestAdditionalDetailsLevel,
				requestFavoriteHeadquarter,
				requestInstitutionalEmail,
				requestOrderDocument,
				requestUserTypeSelection,
				saleType,
				state,
				tags,
				useTags,
				userTypes,
				watcher,
				watchers,
				zone,
				email,
				phoneNumber,
			},
			resolve,
			reject,
			true
		);
	});
};

const updateInstitution = ({
	_id,
	alias,
	allowInstitutionalLogin,
	additionalInformationMessage,
	allowedDeliveryMethods,
	allowedInstitutionalDeliveryMethods,
	allowedInstitutionalPaymentMethods,
	allowedPaymentMethods,
	alternateCode,
	deliveryMethodMessage,
	depots,
	headquarters,
	hidden,
	institutionType,
	name,
	nit,
	nitInstitutional,
	onlyInstitutional,
	publishers,
	requestAdditionalDetails,
	requestAdditionalDetailsLevel,
	requestFavoriteHeadquarter,
	requestInstitutionalEmail,
	requestOrderDocument,
	requestUserTypeSelection,
	saleType,
	state,
	tags,
	useTags,
	userTypes,
	watcher,
	watchers,
	zone,
	email,
	phoneNumber,
}) => {
	return new Promise((resolve, reject) => {
		putRequest(
			`${api}/${_id}`,
			{
				alias,
				allowInstitutionalLogin,
				additionalInformationMessage,
				allowedDeliveryMethods,
				allowedInstitutionalDeliveryMethods,
				allowedInstitutionalPaymentMethods,
				allowedPaymentMethods,
				alternateCode,
				deliveryMethodMessage,
				depots,
				headquarters,
				hidden,
				institutionType,
				name,
				nit,
				nitInstitutional,
				onlyInstitutional,
				publishers,
				requestAdditionalDetails,
				requestAdditionalDetailsLevel,
				requestFavoriteHeadquarter,
				requestInstitutionalEmail,
				requestOrderDocument,
				requestUserTypeSelection,
				saleType,
				state,
				tags,
				useTags,
				userTypes,
				watcher,
				watchers,
				zone,
				email,
				phoneNumber,
			},
			resolve,
			reject,
			true
		);
	});
};

const deleteInstitution = (id) => {
	return new Promise((resolve, reject) => {
		deleteRequest(`${api}/${id}`, resolve, reject, true);
	});
};

const getInstitutionDetails = (id) => {
	return new Promise((resolve, reject) => {
		getRequest(`${api}/${id}`, resolve, reject, true);
	});
};

const getInstitutionByUniqueCode = (uniqueCode) => {
	return new Promise((resolve, reject) => {
		getRequest(`${api}/code/${uniqueCode.trim()}`, resolve, reject, true);
	});
};

const getInstitutions = (
	publicInstitutions = false,
	secure = false,
	simple = false,
	customFilter = false
) => {
	return new Promise((resolve, reject) => {
		getRequest(
			`${api}${
				secure ? "/secure" : ""
			}?publicInstitutions=${publicInstitutions}${
				simple ? "&simple=true" : ""
			}${customFilter ? "&customFilter=true" : ""}`,
			resolve,
			reject,
			true
		);
	});
};

const exportInstitutions = () => {
	return new Promise((resolve, reject) => {
		getRequest(`${api}/export`, resolve, reject, true, null, true);
	});
};

const processInstitutionsTag = (tagId) => {
	return new Promise((resolve, reject) => {
		putRequest(`${api}/processTags/${tagId}`, {}, resolve, reject, true);
	});
};

module.exports = {
	createInstitution,
	deleteInstitution,
	getInstitutionDetails,
	getInstitutions,
	updateInstitution,
	getInstitutionByUniqueCode,
	processInstitutionsTag,
	exportInstitutions,
};
